var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BoxWrap",
        { attrs: { title: _vm.$t("salesKPIManagement.BoxWrap.manage") } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "FPermission",
                  rawName: "v-FPermission",
                  value: { pageName: _vm.pageName, list: ["LIST"] },
                  expression: "{pageName, list: ['LIST']}",
                },
              ],
              staticClass: "action-container",
            },
            [
              _c(
                "el-form",
                {
                  ref: "searchForm",
                  staticClass: "searchForm",
                  attrs: {
                    model: _vm.searchVal,
                    size: "small",
                    inline: "",
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("salesKPIManagement.form.rsmEmpNo"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.rsmEmpNo },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.searchVal, "rsmEmpNo", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("salesKPIManagement.form.rsmEmpName"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.rsmEmpName },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.searchVal, "rsmEmpName", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("salesKPIManagement.form.asmEmpNo"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.asmEmpNo },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.searchVal, "asmEmpNo", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("salesKPIManagement.form.asmEmpName"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.asmEmpName },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.searchVal, "asmEmpName", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("salesKPIManagement.form.empNo") },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.empNo },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.searchVal, "empNo", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("salesKPIManagement.form.empName"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.empName },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.searchVal, "empName", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("salesKPIManagement.form.year") },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.year },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.searchVal, "year", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("salesKPIManagement.form.brand") },
                    },
                    [
                      _c("FormSelect", {
                        attrs: {
                          val: _vm.searchVal.brand,
                          options: _vm.optConfig.prodBrandOptions,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.searchVal, "brand", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer-right" }, slot: "footer-right" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "FPermission",
                      rawName: "v-FPermission",
                      value: { pageName: _vm.pageName, list: ["LIST"] },
                      expression: "{pageName, list: ['LIST']}",
                    },
                  ],
                  attrs: { size: "small", icon: "el-icon-refresh" },
                  on: { click: _vm.resetData },
                },
                [_vm._v(_vm._s(_vm.$t("common.reset")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "FPermission",
                      rawName: "v-FPermission",
                      value: { pageName: _vm.pageName, list: ["LIST"] },
                      expression: "{pageName, list: ['LIST']}",
                    },
                  ],
                  staticClass: "t-search-btn",
                  attrs: { size: "small", icon: "el-icon-search" },
                  on: { click: _vm.searchData },
                },
                [_vm._v(_vm._s(_vm.$t("common.search")))]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "BoxWrap",
        {
          staticClass: "main-table-container",
          attrs: { title: _vm.$t("salesKPIManagement.BoxWrap.list") },
        },
        [
          _c(
            "div",
            { attrs: { slot: "header-right" }, slot: "header-right" },
            [
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "FPermission",
                        rawName: "v-FPermission",
                        value: { pageName: _vm.pageName, list: ["EXPORT"] },
                        expression: "{pageName, list: ['EXPORT']}",
                      },
                    ],
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        _vm.downloadExcel(
                          _vm.$t("salesKPIManagement.common.exportText")
                        )
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.export")))]
                ),
                _vm._v(" "),
                _c("ImportExcel", {
                  directives: [
                    {
                      name: "FPermission",
                      rawName: "v-FPermission",
                      value: { pageName: _vm.pageName, list: ["IMPORT"] },
                      expression: "{pageName, list: ['IMPORT']}",
                    },
                  ],
                  attrs: {
                    "is-loading": _vm.isLoading,
                    "opt-config": _vm.optConfig,
                  },
                  on: {
                    "update:isLoading": function ($event) {
                      _vm.isLoading = $event
                    },
                    "update:is-loading": function ($event) {
                      _vm.isLoading = $event
                    },
                    refresh: _vm.searchData,
                  },
                }),
              ],
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.table.listLoading,
                  expression: "table.listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.table.list,
                stripe: "",
                border: "",
                "highlight-current-row": "",
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "rsmEmpNo",
                  label: _vm.$t("salesKPIManagement.table.rsmEmpNo"),
                  width: "120",
                  fixed: "",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rsmEmpName",
                  label: _vm.$t("salesKPIManagement.table.rsmEmpName"),
                  width: "100",
                  fixed: "",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "asmEmpNo",
                  label: _vm.$t("salesKPIManagement.table.asmEmpNo"),
                  width: "120",
                  fixed: "",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "asmEmpName",
                  label: _vm.$t("salesKPIManagement.table.asmEmpName"),
                  width: "100",
                  fixed: "",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "empNo",
                  label: _vm.$t("salesKPIManagement.table.empNo"),
                  width: "120",
                  fixed: "",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "empName",
                  label: _vm.$t("salesKPIManagement.table.empName"),
                  width: "100",
                  fixed: "",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "brand",
                  label: _vm.$t("salesKPIManagement.table.brand"),
                  fixed: "",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.formatEnum(
                                scope.row.brand,
                                "prodBrandOptions"
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "year",
                  label: _vm.$t("salesKPIManagement.table.year"),
                  fixed: "",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "oneSalesTargetQty",
                  label: _vm.$t("salesKPIManagement.table.JanuaryTargetSales"),
                  width: "110",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "twoSalesTargetQty",
                  label: _vm.$t("salesKPIManagement.table.FebruaryTargetSales"),
                  width: "110",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "threeSalesTargetQty",
                  label: _vm.$t("salesKPIManagement.table.MarchTargetSales"),
                  width: "110",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "fourSalesTargetQty",
                  label: _vm.$t("salesKPIManagement.table.AprilTargetSales"),
                  width: "110",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "fiveSalesTargetQty",
                  label: _vm.$t("salesKPIManagement.table.MayTargetSales"),
                  width: "110",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "sixSalesTargetQty",
                  label: _vm.$t("salesKPIManagement.table.JuneTargetSales"),
                  width: "110",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "sevenSalesTargetQty",
                  label: _vm.$t("salesKPIManagement.table.JulyTargetSales"),
                  width: "110",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "eightSalesTargetQty",
                  label: _vm.$t("salesKPIManagement.table.AugustTargetSales"),
                  width: "110",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "nineSalesTargetQty",
                  label: _vm.$t(
                    "salesKPIManagement.table.SeptemberTargetSales"
                  ),
                  width: "110",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "tenSalesTargetQty",
                  label: _vm.$t("salesKPIManagement.table.OctoberTargetSales"),
                  width: "110",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "elevenSalesTargetQty",
                  label: _vm.$t("salesKPIManagement.table.NovemberTargetSales"),
                  width: "110",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "twelveSalesTargetQty",
                  label: _vm.$t("salesKPIManagement.table.DecemberTargetSales"),
                  width: "110",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "oneEighteenSalesTargetQty",
                  label: _vm.$t(
                    "salesKPIManagement.table.January18TargetSales"
                  ),
                  width: "130",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "twoEighteenSalesTargetQty",
                  label: _vm.$t(
                    "salesKPIManagement.table.February18TargetSales"
                  ),
                  width: "130",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "threeEighteenSalesTargetQty",
                  label: _vm.$t("salesKPIManagement.table.March18TargetSales"),
                  width: "130",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "fourEighteenSalesTargetQty",
                  label: _vm.$t("salesKPIManagement.table.April18TargetSales"),
                  width: "130",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "fiveEighteenSalesTargetQty",
                  label: _vm.$t("salesKPIManagement.table.May18TargetSales"),
                  width: "130",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "sixEighteenSalesTargetQty",
                  label: _vm.$t("salesKPIManagement.table.June18TargetSales"),
                  width: "130",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "sevenEighteenSalesTargetQty",
                  label: _vm.$t("salesKPIManagement.table.July18TargetSales"),
                  width: "130",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "eightEighteenSalesTargetQty",
                  label: _vm.$t("salesKPIManagement.table.August18TargetSales"),
                  width: "130",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "nineEighteenSalesTargetQty",
                  label: _vm.$t(
                    "salesKPIManagement.table.September18TargetSales"
                  ),
                  width: "130",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "tenEighteenSalesTargetQty",
                  label: _vm.$t(
                    "salesKPIManagement.table.October18TargetSales"
                  ),
                  width: "130",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "elevenEighteenSalesTargetQty",
                  label: _vm.$t(
                    "salesKPIManagement.table.November18TargetSales"
                  ),
                  width: "130",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "twelveEighteenSalesTargetQty",
                  label: _vm.$t(
                    "salesKPIManagement.table.December18TargetSales"
                  ),
                  width: "130",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.table.total > 0,
                expression: "table.total>0",
              },
            ],
            attrs: {
              total: _vm.table.total,
              page: _vm.table.currPage,
              limit: _vm.table.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.table, "currPage", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.table, "limit", $event)
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }